import { Link, useMatches } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Box from '@mui/material/Box';

export default function Breadcrumbs() {
  const matches = useMatches();

  const crumbs = matches
    .filter((match) => Boolean(match.handle?.breadcrumb))
    .map((match) => ({
      title: match.handle.breadcrumb,
      path: match.pathname
    }));

  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ mb: 2, px: { xs: 0, sm: 2 } }}>
      <MuiBreadcrumbs aria-label="breadcrumb">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return isLast ? (
            <Typography key={crumb.path} sx={{ color: 'text.primary', fontWeight: 500, fontSize: '14px' }}>
              {crumb.title}
            </Typography>
          ) : (
            <Link key={crumb.path} to={crumb.path} style={{ textDecoration: 'none' }}>
              <Typography sx={{ cursor: 'pointer', fontSize: '14px', color: '#60646D' }}>
                {crumb.title}
              </Typography>
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
}
